module.exports = __webpack_public_path__ + "img/84600.6dd714cd.jpg";